import { render, staticRenderFns } from "./DocumentTypes.vue?vue&type=template&id=04568ef7&scoped=true"
import script from "./DocumentTypes.vue?vue&type=script&lang=js"
export * from "./DocumentTypes.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypes.vue?vue&type=style&index=0&id=04568ef7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04568ef7",
  null
  
)

export default component.exports